/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.6",
    versionName: "0.2.0-nightly.2025.7.6",
    versionChannel: "nightly",
    buildDate: "2025-07-06T00:08:34.102Z",
    commitHash: "7c21c6891e4b0a3bfee31b00b9cbc65af7f7da78",
};
